import styled from 'styled-components';

import {body12Normal} from '~/shared/theme/typography';
import {getLocalizationService} from '~/shared/services/localisationService';
import AuthProviderButton from '~/shared/components/SignIn/AuthProviderButton';
import FacebookIcon from '~/assets/images/icons/facebook-footer.svg?react';

const NeverDetails = styled.div`
  margin-top: 15px;
  ${body12Normal};
  line-height: 1em;
  color: ${({theme}) => theme.colors.secondary};
  text-align: center;
`;

const StyledFacebookIcon = styled(FacebookIcon).attrs({
  viewBox: '0 0 16 16',
  width: 19,
  height: 19,
})`
  path {
    fill: ${({theme}) => theme.colors.facebookBlue};
  }
`;

export interface FacebookSectionProps {
  onClick?: () => void;
}

const FacebookSection = ({onClick}: FacebookSectionProps) => {
  const {t} = getLocalizationService();
  const facebookAdditionAriaLabel = t('we_will_never_publish_any_information_without_your_approval');

  return (
    <>
      <AuthProviderButton
        text={t('continue_with_xxx', {companyName: 'Facebook'})}
        icon={<StyledFacebookIcon />}
        ariaLabel={`${t('quick_register_with_xxx_aria_label', {companyName: 'Facebook'})} ${facebookAdditionAriaLabel}`}
        onClick={onClick}
      />
      <NeverDetails>{facebookAdditionAriaLabel}</NeverDetails>
    </>
  );
};

export default FacebookSection;
